import { NgModule } from '@angular/core';
import { SharedModule } from '../../../core/modules/shared.module';
import { RouterModule, Routes } from '@angular/router';
import { AuthGuard } from '../../../_guards/auth.guard';
import { CreateCorporateUserComponent } from './create-corporate-user.component';
import { DialogComponent } from './dialog/dialog.component';
import { RoleGuard } from '../../../_guards/role.guard';

const routes: Routes = [
    {
        path     : 'create-corporate-user',
        component: CreateCorporateUserComponent,
        data :{
            permission:{
                only :['role1','role2']
            }
        },
        canActivate:[AuthGuard,RoleGuard]
    }
];

@NgModule({
    imports     : [
        SharedModule,
        RouterModule.forChild(routes)
    ],
    declarations: [
      CreateCorporateUserComponent,
      DialogComponent
    ],
    providers:[
        AuthGuard,RoleGuard
    ],
    entryComponents: [DialogComponent]
})
export class CreateCorporateUserModule { }



// WEBPACK FOOTER //
// C:/Users/Lenovo/Desktop/bigadviceadminSkeleton/src/app/main/content/create-corporate-user/create-corporate-user.module.ts